export default (state: any) => state.page?.data?.zone?.smartFaqUUID ?? '';
